import { BrowserPlatform, detectBrowserPlatform } from '../../utils/browserPlatform';
import { env } from '../../utils/env';

/**
 * Where the invite landing sends a friend who does not have the app yet.
 *
 * - `ANDROID_PACKAGE_NAME` - the Play listing's application id. Defaults to the one this build
 *   ships (`android/app/build.gradle`). The invite code rides on the Play URL as the install
 *   `referrer`, which the app reads back on first launch (see `pendingInviteCode`).
 * - `IOS_APP_STORE_URL` - the App Store listing, e.g. https://apps.apple.com/app/id1234567890. No
 *   default: without it the landing offers no App Store button.
 *
 * Both accept the usual platform-suffixed variants (`_WEB`), since the landing is the web build.
 */
const DEFAULT_ANDROID_PACKAGE = 'com.fishandchips.vipsvarastage';

const optionalEnv = (key: string): string | null => {
	try {
		return env(key, ' ')?.trim() || null;
	} catch {
		return null;
	}
};

export const playStoreUrl = (code: string) => {
	const packageName = optionalEnv('ANDROID_PACKAGE_NAME') ?? DEFAULT_ANDROID_PACKAGE;
	const referrer = encodeURIComponent(`invite_code=${code}`);
	return `https://play.google.com/store/apps/details?id=${encodeURIComponent(packageName)}&referrer=${referrer}`;
};

export const appStoreUrl = (): string | null => optionalEnv('IOS_APP_STORE_URL');

/** Opens the installed app on this invite; does nothing if the app is not installed. */
export const appDeepLink = (code: string) => `svara://invite/${encodeURIComponent(code)}`;

export type InvitePlatform = BrowserPlatform;

export const detectInvitePlatform = detectBrowserPlatform;
